import { Dispatch, SetStateAction } from "react";
import { Action } from "redux";
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";
import { getToken } from "./token_fetcher";
import { Job } from "../../shared/queue";
import { DataDownloadFlowJobData, DataDownloadFlowProgress } from "../../model";

export const REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_REQUEST =
  "REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_REQUEST";
export const doREQUEST_PROJECT_DATA_DOWNLOAD_FLOW_REQUEST = createDoRequestAction(
  REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_REQUEST,
);

export const requestProjectDataDownloadFlowRequestActionCreators = {
  doREQUEST_PROJECT_DATA_DOWNLOAD_FLOW_REQUEST,
};

export interface RequestProjectDataDownloadFlowRequestPayload extends Action {
  payload: {
    requestId: string;
    projectId: string;
    participantIds: string[];
    startDate?: Date;
    endDate?: Date;
    force?: boolean;
  };
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>;
}

export interface ProjectDataDownloadFlowRequestResponsePayload {
  payload: {
    job: Job<DataDownloadFlowJobData, DataDownloadFlowProgress>;
    duplicated: boolean;
  };
}

export function* requestProjectDataDownloadFlowRequest({
  payload,
  setRequestResult,
}: RequestProjectDataDownloadFlowRequestPayload): SagaIterator {
  debug("saga*requestProjectDataDownloadFlowRequest");
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        participantIds: v.array().items(v.string().uuid().required()).exist(),
        startDate: v.date().optional(),
        endDate: v.date().optional(),
        force: v.boolean().optional(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_REQUEST,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { projectId, participantIds, startDate, endDate, force } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/project-data-download-flow-request`,
    accessToken,
    data: {
      projectId,
      participantIds,
      startDate,
      endDate,
      force,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_REQUEST,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/project-data-download-flow-request",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_REQUEST,
        fromPayload: payload,
        requestId: payload.requestId,
        url: "/v1/web/project-data-download-flow-request",
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* ProjectDataDownloadFlowRequestSaga() {
  yield takeEvery(
    REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_REQUEST,
    requestProjectDataDownloadFlowRequest,
  );
}
